export enum DeviceMixerType {
	Automixer = 'AUTOMIXER',
	Intellimix = 'INTELLIMIX',
	None = 'NONE'
}
